import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Notificaciones } from 'generated/graphql';

const initialState: Notificaciones[] = [] as any;

const notificacionesSlice = createSlice({
	name: 'notificaciones',
	initialState,
	reducers: {
		setNotificaciones: (state, action: PayloadAction<Notificaciones[]>) => {
			return action.payload;
		}
	}
});

export const { setNotificaciones } = notificacionesSlice.actions;

export default notificacionesSlice.reducer;
